import React from 'react'
import { formatDate } from '../helper/formatDate'
import { Link } from 'react-router-dom'
import { useTranslate } from './TranslationText';
import { formateUAEName } from '../helper/formateUAEName';
import PillBtn from './PillBtn';
import { formatDateTimeToString } from '../helper/formatDateTimeToString';


export default function HorseCard({ item, i, showDownloadPassport, isArabicClass, isFilterSection, isProfilePage = false }) {
    const { translate } = useTranslate();
    const BaseBACKENDURL = process.env.REACT_APP_BACKEND_API;

    const langauge = localStorage.getItem('eahsLang') ?? 'en';
    return (
        <div
            key={i}
            className={isArabicClass ? `${isFilterSection ? 'col-xl-4 col-lg-6' : `col-xl-${!!isProfilePage ? '4' : '3'} col-lg-${!!isProfilePage ? '4' : '6'}`} col-md-12 col-sm-12 col-12  mb-main rtl` : "col-lg-3 col-md-6 col-sm-12 mb-main rtl"}
        >
            <div
                className='hourseCardClass bg-white p-main p-3 d-flex flex-column'

            >
                <div className='horseCardTitle mb-1 d-flex flex-wrap align-items-center gap-2'
                >
                    <span>{item.name}</span>
                    {(item.isLeased) && (
                        <span
                            className="px-2 py-1 rounded"
                            style={{
                                backgroundColor: 'var(--mainGold, #C89C66)',
                                color: '#fff',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                lineHeight: '1'
                            }}
                        >
                            {translate('web.Leased', 'Leased')}
                        </span>
                    )}
                </div>
                <div
                    className='horseCardDescription fw-bold '
                >
                    {translate("web.regno", "Regno")}: {item.registerNumber}
                </div>
                <div className='mt-auto'>
                    <div className='mainSpacer my-2' />
                </div>
                <div className="row ">
                    <div
                        className="col-md-6 col-sm-6 mb-sm-0 mb-2"

                    >
                        <div className='horseCardDescription fw-bold'
                        >
                            <i className='fa fa-globe-americas C89C66 me-1' />{translate("web.origin", "origin")}
                        </div>

                        <div
                            className='horseCardDescription'
                        >
                            {formateUAEName(item.origin)}
                        </div>
                    </div>

                    <div
                        className="col-md-6 col-sm-6"
                    >
                        <div
                            className='horseCardDescription fw-bold'

                        >
                            <i className='fa fa-calendar C89C66 me-1' />{translate("web.birthDate", "Birthdate")}
                        </div>

                        <div
                            className='horseCardDescription'

                        >
                            {item?.birthDateObject ? formatDateTimeToString(item?.birthDateObject) : <>&nbsp;</>}
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className='mainSpacer mt-2 mb-main ' />
                    </div>

                    <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 ms-auto'>
                        <PillBtn isNoPadding={true} isNoMargin={true} isRed={true} text={translate("web.viewDetails", "View Details")} routeName={`/horseDetails?horseId=${item.id}&title=${encodeURIComponent(item.name || '')}`} />
                    </div>
                    {!!showDownloadPassport && (
                        <Link
                            className="position-absolute d-flex align-items-center justify-content-center text-decoration-none"
                            to={`${BaseBACKENDURL}/OwnerProfile/HorsePassport?id=${item.id}`}
                            target="_blank"
                            title={translate('web.ePassport', 'ePassport')}
                            style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: '#6c757d',
                                zIndex: 10,
                                ...(langauge === 'en' ? { top: 20, right: 20 } : { top: 20, left: 20 })
                            }}
                        >
                            <i className="fa-solid fa-download text-white m-0" style={{ fontSize: '16px' }}></i>
                        </Link>
                    )}
                </div>

            </div>
        </div>
    )
}
